// components/Newsletter.js
import React, { useEffect, useState } from 'react'
// import { NavLink } from 'react-router-dom'
// import { toast } from 'react-toastify'
// import ActionBar from '../../components/ActionBar'
// import Search from '../../components/Search'
// import Button from '../../components/shared/Button'
// import { AddIcon } from '../../components/shared/Icons'
import Loader from '../../components/shared/Loader'
import Pagination from '../../components/shared/Pagination'
import Table from '../../components/Table'
import useFetch from '../../hooks/useFetch'
import CaptionLayout from '../../layouts/CaptionLayout'
import Section from '../../layouts/Section'
import SectionBody from '../../layouts/SectionBody'
import { getAllShippingCharges } from '../../utils/Apis/shippingCharges'
import { cn } from '../../utils/helperFunctions'
import { columns } from './COLUMNS'

const Newsletter = ({ className }) => {
  const [currentPage, setCurrentPage] = useState(1)
  const { data, error, loading, refetch } = useFetch({
    fn: getAllShippingCharges,
    args: ['', currentPage],
  })

  useEffect(() => {
    document.title = 'Newsletter Subscriptions - Admin'
  }, [])

  useEffect(() => {
    refetch('', currentPage)
  }, [currentPage])

  return (
    <div className={className}>
      <Section title="Newsletter Subscriptions" className="lg:pb-2" />
      {loading ? (
        <Loader />
      ) : error ? (
        <p>Error: {error.message}</p>
      ) : (
        <SectionBody>
          <CaptionLayout
            results={data?.totalCount}
            caption="Newsletter present"
          >
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              pages={data?.paginationResult?.numberOfPages}
            />
          </CaptionLayout>
          <div
            className={cn(
              'custom-scroll relative max-h-[45vh] w-full overflow-auto md:max-h-[60vh]',
              className,
            )}
          >
            <Table data={data?.data} columns={columns} />
            <div className="pointer-events-none sticky bottom-0 left-0 h-16 w-full bg-gradient-to-t from-background to-transparent" />
          </div>
          <Pagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            pages={data?.paginationResult?.numberOfPages}
          />
        </SectionBody>
      )}
    </div>
  )
}

export default Newsletter
